module.exports = __webpack_public_path__ + "app/principal/principal-kiss-3D9NdYeg.html";